const SENSOR_BATTERY_MIN_MV = 2000;
const SENSOR_BATTERY_MAX_MV = 3500;

function formatBatteryPercentage(value: number): string {
  return `${Math.round(value)} %`;
}

/**
 * Formats event 77 sensor battery data as a user-friendly percentage.
 *
 * Event 77 snapshot payloads usually provide a percentage value (0-100).
 * If a voltage value in mV is received instead, convert it using the known
 * 2000-3500 mV operating range. Invalid or unknown values return null.
 */
export function formatSensorLegendBatteryStatus(
  batteryLevel?: string
): string | null {
  if (!batteryLevel) {
    return null;
  }

  const normalizedInput = batteryLevel.trim();

  if (!normalizedInput) {
    return null;
  }

  const numericValue = Number(normalizedInput.replace(",", "."));

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  if (numericValue >= 0 && numericValue <= 100) {
    return formatBatteryPercentage(numericValue);
  }

  if (
    numericValue >= SENSOR_BATTERY_MIN_MV &&
    numericValue <= SENSOR_BATTERY_MAX_MV
  ) {
    const percentage =
      ((numericValue - SENSOR_BATTERY_MIN_MV) /
        (SENSOR_BATTERY_MAX_MV - SENSOR_BATTERY_MIN_MV)) *
      100;

    return formatBatteryPercentage(percentage);
  }

  return null;
}
